import { createBrowserRouter } from 'react-router-dom';

import LoginRoutes from './LoginRoutes';
// project import
import MainRoutes from './MainRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([LoginRoutes, MainRoutes], {
  basename: process.env.REACT_APP_BASE_NAME,
});

export default router;
